var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChangePassword',{attrs:{"source":2,"eml":_vm.getEmail()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }